/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Changelog_Mark_As_ReadInputs */

const fr_changelog_mark_as_read = /** @type {(inputs: Changelog_Mark_As_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marquer comme lu`)
};

/**

* @param {Changelog_Mark_As_ReadInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const changelog_mark_as_read = /** @type {((inputs?: Changelog_Mark_As_ReadInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Changelog_Mark_As_ReadInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_changelog_mark_as_read(inputs)
});